export enum InternetSpeed {
  NONE = 'NONE',
  
  LESS_THAN_15 = 'LESS_THAN_15',

  BETWEEN_15_30 = 'BETWEEN_15_30',

  MORE_THAN_30 = 'MORE_THAN_30',
}
